export default function Button({title,clickHandle}) {
    return (
        <button className="bg-main-color text-white px-4 py-3 rounded-md" onClick={clickHandle}>
            {title}
        </button>
    )
}